import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './blog-leeg-horizontale-foto.css'

const BlogLeegHorizontaleFoto = (props) => {
  return (
    <div className="blog-leeg-horizontale-foto-container1">
      <Helmet>
        <title>Blog-leeg-horizontale-foto - Schrijf je vrij</title>
        <meta
          property="og:title"
          content="Blog-leeg-horizontale-foto - Schrijf je vrij"
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name4"></NavbarInteractive>
      <div className="blog-leeg-horizontale-foto-blogtitel-en-datum">
        <div className="blog-leeg-horizontale-foto-container2">
          <h1 className="blog-leeg-horizontale-foto-titel BlogTitel">
            De kip in de dierentuin
          </h1>
        </div>
      </div>
      <div className="blog-leeg-horizontale-foto-container3">
        <p className="blog-leeg-horizontale-foto-datum">
          <span>01-01-1011</span>
          <br></br>
        </p>
        <img
          alt="image"
          src="https://images.unsplash.com/photo-1556316918-880f9e893822?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDQxfHxjaGlja2VuJTIwcGVuZ3VpbnxlbnwwfHx8fDE2NzcyNTg2NTM&amp;ixlib=rb-4.0.3&amp;w=1500"
          className="blog-leeg-horizontale-foto-foto"
        />
        <span className="blog-leeg-horizontale-foto-tekst">
          <span>
            &quot;Er was eens een komische kip die altijd bekend stond om haar
            gevatte grapjes. Op een dag besloot ze om een picknick te
            organiseren voor al haar vrienden in de dierentuin. Terwijl ze aan
            het smikkelen waren van hun boterhammen, vroeg de kip aan de
            pinguïn: &quot;Waarom ben jij altijd zo somber, beste vriend?&quot;
            De pinguïn antwoordde: &quot;Omdat ik altijd op mijn billen val,
            zelfs als ik probeer om op mijn voeten te lopen.&quot; Waarop de kip
            lachte en zei: &quot;Nou, volgens mij moet je gewoon op je humor
            vallen in plaats van op je billen!&quot; En zo begonnen ze allemaal
            te lachen en te genieten van de rest van hun picknick met een gevoel
            van vrolijkheid en vriendschap.&quot;
          </span>
          <br></br>
          <br></br>
          <span>
            &quot;Er was eens een komische kip die altijd bekend stond om haar
            gevatte grapjes. Op een dag besloot ze om een picknick te
            organiseren voor al haar vrienden in de dierentuin. Terwijl ze aan
            het smikkelen waren van hun boterhammen, vroeg de kip aan de
            pinguïn: &quot;Waarom ben jij altijd zo somber, beste vriend?&quot;
            De pinguïn antwoordde: &quot;Omdat ik altijd op mijn billen val,
            zelfs als ik probeer om op mijn voeten te lopen.&quot; Waarop de kip
            lachte en zei: &quot;Nou, volgens mij moet je gewoon op je humor
            vallen in plaats van op je billen!&quot; En zo begonnen ze allemaal
            te lachen en te genieten van de rest van hun picknick met een gevoel
            van vrolijkheid en vriendschap.&quot;
          </span>
          <br></br>
          <br></br>
          <span>
            &quot;Er was eens een komische kip die altijd bekend stond om haar
            gevatte grapjes. Op een dag besloot ze om een picknick te
            organiseren voor al haar vrienden in de dierentuin. Terwijl ze aan
            het smikkelen waren van hun boterhammen, vroeg de kip aan de
            pinguïn: &quot;Waarom ben jij altijd zo somber, beste vriend?&quot;
            De pinguïn antwoordde: &quot;Omdat ik altijd op mijn billen val,
            zelfs als ik probeer om op mijn voeten te lopen.&quot; Waarop de kip
            lachte en zei: &quot;Nou, volgens mij moet je gewoon op je humor
            vallen in plaats van op je billen!&quot; En zo begonnen ze allemaal
            te lachen en te genieten van de rest van hun picknick met een gevoel
            van vrolijkheid en vriendschap.&quot;
          </span>
          <br></br>
        </span>
      </div>
      <div className="blog-leeg-horizontale-foto-andere-blogs">
        <h2 className="blog-leeg-horizontale-foto-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="blog-leeg-horizontale-foto-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name1"></Footer>
    </div>
  )
}

export default BlogLeegHorizontaleFoto
